import React from 'react';
import config from '../../../shared/services/config';
import { EMPTY_ARRAY } from '../../../shared/utils/common';

export const TopBar = ({ actionBtns = EMPTY_ARRAY }) => {
  const UI = config.get('uiv2', {})

  return (
    <div className='tw-preflight'>
      <div className='tw-flex tw-flex-wrap tw-justify-between tw-py-16 tw-px-32 tw-bg-green-10'>
        <UI.PayuIcon type='payu-logo' size='32px' color='#0C6150' />
        <span />
        <div className='tw-flex tw-gap-16 tw-shrink-0'>
          {actionBtns.map(({ label, ...restProps }) => <UI.Button {...restProps}>{label}</UI.Button>)}
        </div>
      </div>
    </div>
  )
}